export default __webpack_public_path__ + "afd161cd7cca0c4d548dbafdea5aeb22.png";